import CKEditor from '@ckeditor/ckeditor5-vue'

const CkeditorWithToolbar = {
  extends: CKEditor.component,
  created () {
    this.$on('ready', this.attachEditorToolbar)
  },
  beforeDestroy () {
    const toolbar = this.$_attachedToolbar
    if (toolbar && toolbar.parentNode) {
      toolbar.parentNode.removeChild(toolbar)
    }
    this.$off('ready', this.attachEditorToolbar)
  },
  methods: {
    attachEditorToolbar (editor) {
      const editable = editor.ui.getEditableElement()
      const toolbar = editor.ui.view.toolbar.element

      // Decoupled editors leave their toolbar detached. Classic editors and
      // pages that provide a toolbar container have already placed theirs.
      if (editable && editable.parentNode && toolbar && !toolbar.parentNode) {
        editable.parentNode.insertBefore(toolbar, editable)
        this.$_attachedToolbar = toolbar
      }
    }
  }
}

export default {
  install (Vue) {
    Vue.component('ckeditor', CkeditorWithToolbar)
  }
}
